// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","logo--left":"Logo_logo--left__E-pkM","logo--right":"Logo_logo--right__2HObx","logo--small":"Logo_logo--small__mO06u"};